import React from "react";

interface Props {
	note: string;
}

export function SilencingNote({ note }: Props) {
	return (
		<section className="space-y-3">
			<h2 className="text-15/[22px] text-core-text-neutral-primary">Silencing note</h2>
			{note === "" ? (
				<p className="mb-0 text-13 text-text-core-text-neutral-tertiary">No silencing note provided.</p>
			) : (
				<p className="break-on-word mb-0 text-13 text-core-text-neutral-secondary italic">{note}</p>
			)}
		</section>
	);
}
